import { PRO_NUMBER_VALIDATION_MESSAGES } from "./ValidationMessages";

export const validateProNumberDefault = (enableCheckDigit) => ({
  completedProList,
  proNumber,
  shipmentId,
  proNumberLength,
}) => {
  const isMatchWithCompletedPro = completedProList.find(
    (pro) => Number(pro.proNumber) === Number(proNumber)
  );
  if (!proNumber) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).required;
  } else if (
    proNumber.trim().match('^([0])\\1*$') ||
    Number(proNumber.trim()) < 0 ||
    isNaN(Number(proNumber.trim()))
  ) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).invalidProNumber;
  } else if (proNumber && proNumber.trim().length > proNumberLength) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).proNumberMax;
  } else if (
    enableCheckDigit &&
    proNumber.trim().length < proNumberLength
  ) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).proNumberMin;
  } else if (
    enableCheckDigit &&
    proNumber.trim().length === proNumberLength
  ) {
    const enteredCheckDigit = proNumber.slice(-1);
    const calculatedCheckDigit = getCheckDigit(
      proNumber.slice(0, proNumberLength - 1),
      proNumberLength,
    );

    if (Number(enteredCheckDigit) !== Number(calculatedCheckDigit)) {
      return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).invalidCheckDigit;
    }
  } else if (isMatchWithCompletedPro) {
    const completedProData = completedProList.find(
      (pro) => Number(pro.proNumber) === Number(proNumber)
    );
    if (completedProData?.shipmentId !== shipmentId) {
      return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).duplicateNumber;
    }
  }
  return null;
};

function getCheckDigit(proNumber, proNumberLength) {
  if (isNaN(Number(proNumber))) {
    return proNumber;
  }

  if (proNumber.length < proNumberLength - 1) {
    proNumber = proNumber.padStart(proNumberLength - 1, "0");
  }
  const actualProNumber = Number(proNumber.substr(0, proNumberLength - 2));
  const getCalcDigit = Math.floor(actualProNumber / 7);
  return actualProNumber - getCalcDigit * 7;
}

export const getProNumberDefault =
  (enableCheckDigit) =>
  ({ proNumber, proNumberLength }) => {
    if (enableCheckDigit) {
      return proNumber + getCheckDigit(proNumber, proNumberLength).toString();
    }
    return proNumber;
  };
